<template>
    <CustomTopSheetDialog v-model="show" :width="600" :title="null" :customclass="'px-4 pt-4'">
        <template #title>
            <h3 class="text-left dialog-title" color="primary">
                {{$t('fairling.stream.delete.title')}}
            </h3>
        </template>

        <template #default>
            <p>
                {{$t('fairling.stream.delete.hint')}}
            </p>
        </template>

        <template #actions>
            <v-container class="d-flex align-items-center justify-content-end">
                <v-btn class="px-3 py-1 mr-3" variant="flat" rounded="xl" size="large" prepend-icon="mdi-cancel"
                    color="default" @click="closeSheet">{{ $t('entity.action.cancel') }}</v-btn>
                <v-btn class="px-3 py-1" variant="flat" rounded="xl" size="large" prepend-icon="mdi-trash-can"
                    color="error" @click="confirmDeletion">{{$t('global.yes')}}</v-btn>
            </v-container>
        </template>
    </CustomTopSheetDialog>
</template>


<script>
export default {
    name: "ConfirmDeletionDialog",
    props: {
        modelValue: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        show: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit("update:modelValue", value);
            },
        },
    },
    methods: {
        closeSheet() {
            this.show = false;
        },
    },
};
</script>
<script setup>
import { ref, defineEmits } from 'vue';
import CustomTopSheetDialog from '@/components/custom/CustomTopSheetDialog.vue';


const emit = defineEmits(['confirm-delete'])

const confirmDeletion = () => {
    emit('confirm-delete');
}

 
</script>
